interface CarouselItem {
  title: string;
  category: string;
  description: string;
  imageUrl: string;
  imageAlt: string;
}

const carouselItems: CarouselItem[] = [
  {
    title: '2026上半年塌房明星大盘点：谁最让你意外？',
    category: '年度盘点',
    description: '汇总上半年娱乐圈重大塌房事件，涉及顶流明星、知名导演等多个重磅人物。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dramatic%20collage%20style%20illustration%20of%20entertainment%20scandals%20year%20review%2C%20warm%20vermillion%20and%20dark%20amber%20tones%2C%20abstract%20newspaper%20clippings%20aesthetic%2C%20editorial%20design%20style%2C%20dramatic%20lighting%2C%20modern%20Chinese%20graphic%20design&width=700&height=400&seq=carousel-item-01&orientation=landscape',
    imageAlt: '2026上半年塌房明星大盘点专题封面',
  },
  {
    title: '综艺翻车名场面合集：那些让导演崩溃的瞬间',
    category: '综艺考古',
    description: '回顾近年综艺节目中那些令人捧腹又尴尬的翻车名场面。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Colorful%20abstract%20TV%20show%20moments%20collage%20with%20dramatic%20expressions%2C%20warm%20golden%20and%20coral%20color%20palette%2C%20entertainment%20editorial%20illustration%20style%2C%20dynamic%20composition%2C%20soft%20cinematic%20glow&width=700&height=400&seq=carousel-item-02&orientation=landscape',
    imageAlt: '综艺翻车名场面合集专题封面',
  },
  {
    title: '网红圈乱象深度调查：流量背后的灰色产业链',
    category: '深度调查',
    description: '揭开网红经济背后的刷量、虚假人设和数据造假的完整产业链。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20investigative%20journalism%20illustration%20of%20social%20media%20industry%20secrets%2C%20warm%20amber%20and%20deep%20coral%20tones%2C%20abstract%20data%20visualization%20patterns%2C%20editorial%20documentary%20style%2C%20dramatic%20shadows&width=700&height=400&seq=carousel-item-03&orientation=landscape',
    imageAlt: '网红圈乱象深度调查专题封面',
  },
  {
    title: '吃瓜群众必修课：如何辨别真假爆料信息？',
    category: '吃瓜指南',
    description: '资深瓜友教你识别网络谣言、假爆料和营销号的惯用套路。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Educational%20illustration%20about%20media%20literacy%20and%20fact%20checking%2C%20warm%20cream%20and%20coral%20color%20scheme%2C%20magnifying%20glass%20metaphor%20abstract%20design%2C%20clean%20editorial%20style%2C%20soft%20natural%20lighting&width=700&height=400&seq=carousel-item-04&orientation=landscape',
    imageAlt: '吃瓜群众必修课：辨别真假爆料专题封面',
  },
  {
    title: '影视圈寒冬下的生存法则：从业者亲述现状',
    category: '行业观察',
    description: '多位影视行业从业者匿名分享当前行业困境与转型出路。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Film%20industry%20behind%20the%20scenes%20atmospheric%20illustration%2C%20warm%20dark%20amber%20and%20golden%20tones%2C%20cinematic%20lighting%20with%20abstract%20film%20equipment%20shapes%2C%20editorial%20documentary%20photography%20style%2C%20moody%20composition&width=700&height=400&seq=carousel-item-05&orientation=landscape',
    imageAlt: '影视圈寒冬生存法则专题封面',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
            焦点专题
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            精选深度专题内容，从不同角度带你吃透每一颗大瓜
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4 md:gap-5">
          {carouselItems.map((item, idx) => (
            <div
              key={idx}
              className="group bg-background-100 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="relative w-full aspect-[16/10] overflow-hidden">
                <img
                  src={item.imageUrl}
                  alt={item.imageAlt}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="inline-block px-2 py-0.5 rounded-full bg-primary-500 text-white text-xs font-medium">
                    {item.category}
                  </span>
                </div>
              </div>
              <div className="p-3 md:p-4">
                <h3 className="text-sm font-medium text-foreground-800 mb-1.5 group-hover:text-primary-500 transition-colors line-clamp-2">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">
                  {item.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}